var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    {
      staticClass: "fill-height justify-center",
      attrs: { id: "certificateView", tag: "section" }
    },
    [
      !_vm.busy
        ? _c(
            "div",
            { attrs: { width: "100%" } },
            [
              _c("certificate-badge", {
                attrs: { id: _vm.certificate.sn, model: _vm.certificate }
              }),
              _c(
                "a",
                {
                  attrs: { href: "#" },
                  on: {
                    click: function($event) {
                      return _vm.downloadmodel(_vm.certificate.sn)
                    }
                  }
                },
                [
                  _vm._v(
                    _vm._s(_vm.$t("certficateDisplay.download-certificate"))
                  )
                ]
              )
            ],
            1
          )
        : _vm._e(),
      _vm.busy
        ? _c(
            "div",
            [
              _c(
                "v-overlay",
                { attrs: { value: _vm.busy } },
                [
                  _c("v-progress-circular", {
                    attrs: { indeterminate: "", size: "56" }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }